import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RocketIcon = _resolveComponent("RocketIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "padding" }, null, -1)),
    _createVNode(_component_RocketIcon),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "padding" }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "footer-container" }, [
      _createElementVNode("p", null, "© Jonathan Pizarra 2025"),
      _createElementVNode("p", null, "|"),
      _createElementVNode("p", null, [
        _createElementVNode("a", { href: "https://github.com/jonathanpizarra" }, "Github")
      ])
    ], -1))
  ], 64))
}